import { Skeleton } from "@/components/ui/skeleton";

/**
 * Tela neutra exibida enquanto o AuthProvider valida a sessão armazenada
 * (boot do app). Compartilhada pelos guards de rota protegida e de visitante.
 */
export const SessionLoadingFallback = () => (
  <div
    role="status"
    aria-label="Validando sessão"
    className="min-h-screen flex items-center justify-center"
  >
    <div className="space-y-3">
      <Skeleton className="h-12 w-12 rounded-full mx-auto" />
      <Skeleton className="h-4 w-32" />
    </div>
  </div>
);
